import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from '../uitk-badge.css';

var getClassNameList = classNames.bind(styles);
/**
 * @deprecated do not use
 */
var UitkFloatingDotNotificationBadge = function (props) {
    var className = props.className, visible = props.visible;
    var baseClassName = 'uitk-badge-floating-dot-notification';
    var wrapperClassNames = getClassNameList(baseClassName, visible && "".concat(baseClassName, "-is-visible"), className);
    return React.createElement("div", { className: wrapperClassNames });
};
UitkFloatingDotNotificationBadge.defaultProps = {
    visible: true
};
UitkFloatingDotNotificationBadge.displayName = 'UitkFloatingDotNotificationBadge';

export { UitkFloatingDotNotificationBadge };
